import React from 'react';
import russianmanicure from '../assets/russianmanicure.jpg';
import Nailserice from '../assets/nailser.jpeg';
import nailextension from '../assets/nailextension.jpg';
import russianpedicure from '../assets/russianpedicure.jpg'
import './Service.css';
const Nails = () => {
  return (
    <>
          <div className="">
        <img src={Nailserice} alt="Beauty Destination" className="full-screen-image bgimg" />
   </div>
<div className="d-flex justify-content-center pt-5">
<h1 style={{ color: '#b37777', fontStyle: 'italic', fontFamily: "'TAN TWINKLE', cursive" }}> Nail Services</h1>
</div>
   <div className="container pt-4">
    <div className="row align-items-center animate-form1 servicecontainer">
        <div className="col-sm-6">
            <h1 className="service-header text-center">Manicure gel Polish</h1>
            <p>
              Get vibrant, chip-free nails that shine for up to 3 weeks! Our premium gel polish offers a flawless, glossy finish in a wide range of stunning colors and designs. 
              Experience salon-quality nails at home. Durable, effortless, and always beautiful!              
            </p>
            <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
        </div>
        <div className="col-sm-6">
            <img src={russianmanicure} alt="Nail Services" style={{width: "100%", height: "500px"}} />
        </div>
       
    </div>
    <div className="row align-items-center animate-form servicecontainer">
      
      <div className="col-sm-6">
          <img src={nailextension} alt="Nail Services" style={{width: "100%", height: "500px"}} />
      </div>
      <div className="col-sm-6">
        <h1 className="service-header text-center pt-2">Poly Gel Extension </h1>
        <p>
          Achieve flawless, durable nails with our Poly Gel Extensions! 
          Lightweight, flexible, and easy to shape, they combine the best of gel and acrylic for a natural, long-lasting finish. Perfect for custom styles and lengths—your dream nails start here. 
          Visit [Your Website] and elevate your manicure game today!        
        </p>
        <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
  </div>
  <div className="row align-items-center animate-form1 servicecontainer">
    <div className="col-sm-6">
        <h1 className="service-header text-center">Russian Gel Pedicure</h1>
        <p>
          Experience the luxury of a Russian Gel Pedicure—the ultimate in precision and perfection for your feet! This advanced technique ensures immaculate cuticle care, flawless shaping, and a long-lasting gel polish finish. Perfect for those who value detail and durability. 
          Treat yourself to the best—visit MSlikSpa to book your appointment today!       
        </p> 
        <p className="service-price"><strong>Pricing:</strong> Starts from $XX</p>
    </div>
    <div className="col-sm-6">
        <img src={russianpedicure} alt="Nail Services" style={{width: "100%", height: "500px"}} />
    </div>
   
</div>
</div>


    </>
  )
}

export default Nails